import React, { useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import qs from 'query-string'
import { useLazyQuery } from '@apollo/react-hooks'
import { path } from 'ramda'
import PropTypes from 'prop-types'

import VOUCHER_WITH_UPGRADE_SKU_QUERY from '../../../../graphql/queries/voucher-with-upgrade-sku.gql'
import { getGQLErrorMsg } from '../../../lib/apollo'
import VoucherForm from '../../shared/components/voucher-form'
import { modalContent } from '../../shared/subscription-constants'
import useStyles from '../styles'

const Voucher = ({ product }) => {
  const styles = useStyles()
  const location = useLocation()
  const history = useHistory()
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [voucher, setVoucher] = useState('')

  const [validateVoucher] = useLazyQuery(VOUCHER_WITH_UPGRADE_SKU_QUERY, {
    onCompleted: result => {
      setSubmitting(false)
      const voucherCode = path(['voucherWithUpgradeSku', 'code'], result)
      history.push({
        ...location,
        search: qs.stringify({
          ...qs.parse(location.search),
          content: modalContent.payment,
          voucher: voucherCode
        })
      })
    },
    onError: errorResult => {
      setSubmitting(false)
      const errorMsg = getGQLErrorMsg(errorResult)

      setError(errorMsg)
    }
  })

  const addVoucherHandler = () => {
    setSubmitting(true)
    setError('')
    validateVoucher({
      variables: {
        voucherCode: voucher,
        upgradeSku: product.sku
      }
    })
  }

  const skipVoucherHandler = () => {
    const search = qs.parse(location.search)
    delete search.voucher

    history.push({
      ...location,
      search: qs.stringify({
        ...search,
        content: modalContent.payment
      })
    })
  }

  return (
    <div className={styles.container}>
      <VoucherForm
        voucherValue={voucher}
        onVoucherChange={setVoucher}
        onRedeem={addVoucherHandler}
        onSkip={skipVoucherHandler}
        error={error}
        isSubmitting={submitting}
      />
    </div>
  )
}

Voucher.propTypes = {
  product: PropTypes.shape({
    sku: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired
}

export default Voucher
